import view from "../../views/solo.js";
import { router } from "../router/index.routes.js";
import KTAPI from "../api/index.api.js";
import { ioSocket, ioPings } from "../mm/index.mm.js";

import { _user, _handler, getEloLevel, Toasted, Countdown, CustomDialog, storage, soundManager, getPingColor, CountUp } from "../classes/index.classes";
import error from "./error.controller.js";


let regions = [];
let availableRegions = [];
let confimDialog = null;

let play = {
    render: () => {        
        return view;
    },
    after_render: async () => {
        if(!_user.authed) {router.navigate("error");return;}
        
        initSolo();        
        
    },
    root: false, 
    rerender: true,
    rendered: false,
    where: '#kt_content'
};

async function initSolo() {
    //console.log("init solo", storage.get("soloSettings"));
    if(storage.get("soloSettings") == null)
    {
        console.log("solo settings not found");
        storage.set("soloSettings", {
            autoaccept: false,
            autoconnect: false
        });
        console.log("solo settings created");
    }
    
    let svPool = await KTAPI.getSvPool();
    if(svPool.message == "done")
    {
        renderServers(svPool.res);
    }
    else
    {
        //errorDlg(svPool.error);
    }

    let res = await KTAPI.inQueue();
    if(res.message == "done")
    {
        renderMemberSolo();
        renderSoloBtn(res.isInQueue);
    }
    else
    {
        errorDlg(res.error);
    }

    $(document).off("click", ".solo-confirm-match");
    $(document).on("click", ".solo-confirm-match", async function(){
        $(this).addClass("disabled");
        let res = await KTAPI.confirmQueue();
    });
}

const soloOffscreenInit = async () => {
    let res = await KTAPI.inQueue();
    if(res.message == "done")
    {
        renderToolbar(res.isInQueue);
    }
    else
    {
        errorDlg(res.error);
    }
}

async function renderSoloBtn(queue) {
    let cont = ``;
    if(queue == null)
    {
        cont = `
            <button class="btn btn-lg btn-flex btn-light-primary border-hover-primary btn-active-primary btn-active-color-gray-100 solo-btn-start shadow-sm" style="box-shadow: 0 0.1rem 1rem 0.25rem #ff8f003d !important;">
                                <i class="fad fa-play fs-4 me-1 text-uppercase"></i><span class="" data-i18n="solo.start">START MATCHING</span>
                            </button>
        `;
        cont = $(cont);
        cont.localize();
    }
    else
    {
        cont = `
            <button class="btn btn-lg btn-flex btn-light-danger btn-active-light-danger btn-active-color-gray-900 btn-color-gray-900 shadow-sm" style="box-shadow: 0 0.1rem 1rem 0.25rem #ff1b213d !important;">
                                <div class="d-flex align-items-center justify-content-between gap-4">
                                    <div class="d-flex flex-column align-items-center justify-content-center">
                                        <span class="" data-i18n="solo.cancel">FINDING MATCH</span>
                                        <span class="min-w-80px searching-countup"></span>
                                    </div>
                                    <span class="btn btn-icon btn-sm btn-danger btn-active-danger btn-active-color-gray-100 z-index-3 solo-btn-stop" data-i18n="[title]solo.cancel" data-toggle="tooltip" title="Cancel search"><i class="fal fa-times fs-4"></i></span>
                                    </span>
                                </div>
                                <!--<div class="bg-spinner-container">
                                    <div class="bg-spinner-label">
                                        <span class="searching-countup"></span>
                                    </div>
                                </div>-->
                            </button>
        `;
        cont = $(cont);
        cont.localize();        
    }
    $(".solo-btn-matching").html(cont);
    if(queue != null)
    {
        let startSeconds = Math.floor(Date.now() / 1000) + parseInt(hostStampDif);
        startSeconds = startSeconds - parseInt(queue.joinedAt);
        //console.log("countup", Math.floor(Date.now() / 1000), parseInt(hostStampDif), parseInt(queue.startedAt));
        //console.log("countup", startSeconds); 
        let countup = new CountUp({startSeconds, displayElement: ".searching-countup"});
        countup.start();

        regions = queue.regions;
        $(".solo-servers-num-selected").text(regions.length);
        availableRegions.map(loc => {
            if(regions.includes(loc))
            {
                $(".solo-servers [name=solo-locations][value="+loc+"]").prop("checked", true);
            }
        });
        

        $(".solo-servers").addClass("custom-disabled");
    }
    else
    {
        $(".solo-servers").removeClass("custom-disabled");
    }
}

function renderMemberSolo() {
    console.log(_user.me);
    let empty = `<div class="d-none col d-md-block">
                            <div class="card card-stretch h-100">
                                <div class="card-body d-flex justify-content-center">
                                    <div class="d-flex flex-column align-items-center justify-content-center">
                                        <i class="fad fa-lock-alt fs-2 text-muted opacity-75"></i>
                                    </div>
                                </div>
                            </div>
                        </div>`;
    let level = getEloLevel(_user.me.stats.rating, _user.me.stats.rd);
    let cont = `
        ${empty}
        ${empty}
        <div class="col mw-175px ms-auto me-auto">
            <div class="card card-stretch bg-gray-100 bg-gradient">
                <div class="card-body d-flex justify-content-center">
                    <div class="d-flex flex-column align-items-center justify-content-center gap-2 w-100px ">
                        <div class="" data-toggle="tooltip" title="${_user.me.city} ${_user.me.country}">
                            <img src="assets/media/flags/${_user.me.countrycode.toLowerCase()}.gif" alt="image" class="mw-100px h-auto">
                        </div>
                        <div class="symbol symbol-50px">
                            <img src="${_user.me.avatar}" alt="image">
                        </div>
                        <div class="w-100 text-truncate text-center overflow-hidden dnickt" data-toggle="tooltip" title="">
                            <span class="fw-bold text-gray-900 fs-7 pt-1 text-white dnick"></span>
                        </div>
                        <div class="text-center">${_user.me.stats.rating}</div>
                        <div class=""><img src="assets/media/ranks/rank_${level.level}.png" alt="image" class="h-35px">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        ${empty}
        ${empty}
    `;

    cont = $(cont);
    cont.find(".dnick").text(_user.me.nickname);
    cont.find(".dnickt").attr("title", _user.me.nickname);
    cont.localize();
    cont.find("[data-toggle=tooltip]").tooltip();
    $(".solo-members").html(cont);
}

async function renderServers(data) {
    let cont = ``;
    data.map(sv => {
        let loc = sv._id;
        cont+=`
            <!--<input type="checkbox" class="btn-check" name="solo-locations" id="${loc.city}-${loc.location}" value="${loc.location}">
            <label class="btn btn-color-gray-muted border border-muted border-active-success border-hover-success btn-active-light-success btn-active-color-success d-flex flex-column align-items-center mb-5" for="${loc.city}-${loc.location}">                
                <span class="d-block fw-semibold text-center">
                    <span class="text-gray-800 fw-bold d-block fs-7">${loc.region}</span>                    
                </span>
                <span class="text-gray-700"><span><i class="bi bi-bar-chart-fill pe-0 ${getPingColor(ioPings[loc.location] === undefined ? 9999 : ioPings[loc.location])}" data-iconping="${loc.location}"></i>
                <span class="fw-bold fs-7 my-1 text-nowrap" data-showping="${loc.location}">${ioPings[loc.location] === undefined || ioPings[loc.location].ping == 0 ? `<div    class="spinner-border text-primary text-center" role="status" style="width: 11px; height: 11px;"><span class="visually-hidden">Loading...</span></div>` : ioPings[loc.location].ping}</span></span>
                <span class="fs-7">ms</span></span>
            </label>-->

            <div class="form-check form-check-custom form-check-solid mb-3" data-toggle="tooltip" title="${loc.region}">
                <input class="form-check-input" type="checkbox" name="solo-locations" value="${loc.location}" id="${loc.city}-${loc.location}"/>
                <label class="form-check-label d-flex flex-row justify-content-between align-items-center w-100" for="${loc.city}-${loc.location}">
                    
                    <span class="d-flex fw-semibold text-center align-items-center">
                        <span><img class="me-2" height="12" width="18" src="assets/media/flags/${loc.flag}.gif"></span><span class="text-gray-800 d-block fs-7">${loc.city} ${loc.location}</span>
                    </span>

                    <span class="text-gray-800">
                        <span>
                            <i class="bi bi-bar-chart-fill pe-0 ${getPingColor(ioPings[loc.location] === undefined ? 9999 : ioPings[loc.location])}" data-iconping="${loc.location}"></i>
                            <span class="fs-7 my-1 text-nowrap" data-showping="${loc.location}">${ioPings[loc.location] === undefined || ioPings[loc.location].ping == 0 ? `<div    class="spinner-border text-primary text-center" role="status" style="width: 11px; height: 11px;"><span class="visually-hidden">Loading...</span></div>` : ioPings[loc.location].ping}
                            </span>
                        </span>
                        <span class="fs-7">ms</span>
                    </span>
                    
                </label>
            </div>
        `;

        availableRegions.push(loc.location);
    });
    
    $(".solo-servers").html(cont);
    $(".solo-servers").localize();
    $(".solo-servers [data-toggle=tooltip]").tooltip();

    availableRegions.map(loc => {
        if(regions.includes(loc))
        {
            $(".solo-servers [name=solo-locations][value="+loc+"]").prop("checked", true);
        }
    });
}

async function errorDlg(error) {
  
    let title = `<span><i class="fas fa-exclamation-circle text-danger fs-4 me-2"></i><span class="" data-i18n="error.solo.error"></span></span>`;
    let content = `<p class="mb-1 text-gray-800" data-i18n="error.solo.${error}"></p>`;
    let accept = `<span class="" data-i18n="error.solo.close"></span>`;    

    title = $(title).localize();
    content = $(content).localize();
    accept = $(accept).localize().text();    

    // Envuelve la lógica del diálogo en una Promesa
    const dialogResult = await new Promise((resolve) => {
        const dialog1 = new CustomDialog({
            title: title[0].outerHTML,
            content: content[0].outerHTML,
            buttons: [{
                    text: accept,
                    class: 'btn btn-sm btn-primary btn-text-gray-100 btn-active-light-primary btn-active-color-primary fw-bolder',
                    callback: function () {
                        resolve('accept');
                    },
                    dismiss: true
                },                
            ],
            onHide: function () {
                
            },
            disableCloseButton: false,
            noBackdrop: false,
            verticallyCentered: true,
            scrollable: true
        });

        dialog1.show();
    });

    // Usa el resultado de la Promesa para continuar con la lógica correspondiente
    if (dialogResult === 'accept') {
        //console.log('Aceptado');
        // Lógica para manejar la aceptación
        return 1
    } else {
        //console.log('Cancelado');
        // Lógica para manejar la cancelación
        return 0;
    }
}

async function settingsDlg() {
    let title = `<span class="" data-i18n="solo.settings_dlg_title"></span>`;  
    let soloSettings = storage.get("soloSettings");


    let content = `<div class="input-group">
                        <div class="mb-10">
                            <!--begin::Label-->
                            <label class="form-label fw-semibold fs-7" data-i18n="solo.autoaccept">Automatically accept the match</label>
                            <!--end::Label-->

                            <!--begin::Switch-->
                            <div class="form-check form-switch form-switch-sm form-check-custom form-check-solid">
                                <input id="solo-autoaccept" class="form-check-input" type="checkbox" name="notifications" ${soloSettings.autoaccept ? 'checked="true"' : ""}>
                                <label class="form-check-label">                                    
                                </label>
                            </div>
                            <!--end::Switch-->
                        </div>
                        <div class="mb-10">
                            <!--begin::Label-->
                            <label class="form-label fw-semibold fs-7" data-i18n="solo.autoconnect">Automatically connect to game server</label>
                            <!--end::Label-->

                            <!--begin::Switch-->
                            <div class="form-check form-switch form-switch-sm form-check-custom form-check-solid">
                                <input id="solo-autoconnect" class="form-check-input" type="checkbox" name="notifications" ${soloSettings.autoconnect ? 'checked="true"' : ""}>
                                <label class="form-check-label">                                    
                                </label>
                            </div>
                            <!--end::Switch-->
                        </div>

                        
                    </div>`;

    title = $(title).localize().text();

    content = $(content).localize();

    // Envuelve la lógica del diálogo en una Promesa
    const dialogResult = await new Promise((resolve) => {
        const dialog1 = new CustomDialog({
            title: title,
            content: content[0].outerHTML,
            buttons: [
            ],
            onHide: function () {
                
            },
            onShow: function() {
                
            },
            disableCloseButton: false,
            noBackdrop: false,
            verticallyCentered: true,
            scrollable: true,
            dialogClasses: "modal-sm"
        });

        dialog1.show();
    });

    
    if (dialogResult === 'accept') {
        
        return 1
    } else {
        
        return 0;
    }
}

async function confirmMatchDlg(data) {
    
    let title = `<span class="text-gray-100 teko-header fs-2" data-i18n="solo.confirm_match_dlg_title">YOUR MATCH IS READY</span>`;
    let content = `<div class="d-flex flex-column align-items-center justify-content-center">
                        
                        <div class="solo-queue-list d-flex flex-column align-items-center justify-content-center mb-6">
                            <span class="text-gray-800 fs-6" data-i18n="solo.confirm_match_dlg_text">Confirm your match:</span>
                            <span class="text-primary fs-5 fw-bold" data-i18n="solo.confirm_match_dlg_text2">Solo Ranked</span>
                        </div>
                        <span class="count-confirm text-white fs-2 teko-header"></span>
                        
                    </div>
                    `;
    
    let accept = `<span class="" data-i18n="party.invite_dlg_accept"></span>`;    
    
    title = $(title).localize();
    content = $(content).localize();
    accept = $(accept).localize().text();
    router.updatePageLinks();

    // Envuelve la lógica del diálogo en una Promesa
    const dialogResult = await new Promise((resolve) => {
        const dialog1 = new CustomDialog({
            title: title[0].outerHTML,
            content: content[0].outerHTML,
            buttons: [
                {
                    text: accept,
                    class: `btn btn-primary btn-color-gray-200 btn-active-color-gray-100 solo-confirm-match`,
                    callback: function () {
                        soundManager.stopSound("match_found");
                        soundManager.playSound("letsgo");
                        resolve('accept');
                    },
                    dismiss: false
                },
            ],
            onHide: function () {
                
            },
            onShow: function() {
                let count = new Countdown({
                    displayElement: '.count-confirm',
                    seconds: parseInt(data.confirmationTimeout/1000),
                });
                count.start();
                router.updatePageLinks();
            },
            disableCloseButton: true,
            noBackdrop: false,
            verticallyCentered: true,
            scrollable: true,
            autoHide: true,
            autoHideDelay: data.confirmationTimeout,
            headerClasses: "bg-primary",
            footerClass: "justify-content-center",
        });
        confimDialog = dialog1;

        dialog1.show();
    });

    // Usa el resultado de la Promesa para continuar con la lógica correspondiente
    if (dialogResult === 'accept') {
        //console.log('Aceptado');
        // Lógica para manejar la aceptación
        return 1
    } else {
        //console.log('Cancelado');
        // Lógica para manejar la cancelación
        return 0;
    }
}

let toolBarCountUp = null;
async function renderToolbar(data)
{
    if(data === undefined || data == null)
    {
        if(toolBarCountUp != null) toolBarCountUp.stop();
        $(".matchmaker-toolbar-container").html("");
        return;
    }

    let cont = `<div data-navigo href="play/solo" class="cursor-pointer bg-fancy w-175px h-35px rounded bg-body me-1">                                    
                                        <!--<span class="searching-countup-toolbar text-gray-900 position-absolute z-index-3 start-50 top-50" style="transform: translate(-50%,-50%);"></span>-->
                                        <div class="position-absolute z-index-3 start-50 top-50 fs-8" style="transform: translate(-50%,-50%);">
                                            <span class="d-flex flex-nowrap gap-2 align-items-center"><span class="text-gray-800 text-nowrap">FINDING MATCH</span><span class="searching-countup-toolbar text-gray-900 fs-7 fw-bolder"></span></span>
                                        </div>
                                </div>
                <button class="btn btn-icon btn-sm btn-light-danger btn-active-danger btn-active-color-gray-100 z-index-3 solo-btn-stop" data-i18n="[title]solo.cancel" data-toggle="tooltip" data-bs-trigger="hover" data-bs-dismiss="click" data-bs-placement="bottom" title="Cancel search"><i class="fal fa-times fs-4"></i></button>`;
    
    cont = $(cont);
    cont.localize();
    $(".matchmaker-toolbar-container").html(cont);
    let startSeconds = Math.floor(Date.now() / 1000) + parseInt(hostStampDif);
    startSeconds = startSeconds - parseInt(data.joinedAt);
    toolBarCountUp = new CountUp({startSeconds, displayElement: ".searching-countup-toolbar"});
    toolBarCountUp.start();  
    cont.find("[data-toggle=tooltip]").tooltip({trigger: "hover"});
    router.updatePageLinks();
}



$(document).ready(function(){
    $(document).on("click", ".solo-btn-settings", async function(){
        settingsDlg();
    });

    $(document).on("change", "#solo-autoaccept", async function(){
        let val = $(this).is(":checked");
        //console.log(val);
        let soloSettings = storage.get("soloSettings");
        soloSettings.autoaccept = val;
        storage.set("soloSettings", soloSettings);        
    });

    $(document).on("change", "#solo-autoconnect", async function(){
        let val = $(this).is(":checked");
        //console.log(val);
        let soloSettings = storage.get("soloSettings");
        soloSettings.autoconnect = val;
        storage.set("soloSettings", soloSettings);                
    });

    $(document).on("change", "[name=solo-locations]", async function(){
        let loc = $(this).val();
        let checked = $(this).is(":checked");

        if(checked)
        {
            if(!regions.includes(loc))
            {
                regions.push(loc);
            }
            $(".solo-servers-num-selected").text(regions.length);
        }
        else
        {
            if(regions.includes(loc))
            {
                regions = regions.filter(item => item !== loc);
            }
            $(".solo-servers-num-selected").text(regions.length);
        }
        await KTAPI.setSoloRegions({regions});
    });

    $(document).on("click", ".solo-btn-start", async function(){
        if(regions.length == 0)
        {            
            errorDlg("no_server_selected"); return;
        }
        let data = {
            regions: regions
        };
        //console.log(data);
        let res = await KTAPI.joinQueue(data);
        if(res.message == "done")
        {
            console.log("joined queue action", res);
        }
        else
        {
            errorDlg(res.error);
        }
    });

    $(document).on("click", ".solo-btn-stop", async function(){
        let res = await KTAPI.leaveQueue();
        if(res.message == "done")
        {
            console.log("left queue action", res);
        }
        else
        {
            errorDlg(res.error);
        }
    });
});

/**
 * 
 *  SOCKET.IO PROCESSESS
 * 
 */

const soloSocket = (socket) => {
        
    socket.on("queue_joined", async (data) => {
        console.log("queue_joined notification", data);
        if(data.message == "done")
        {
            //router.navigate("match/"+data.lobby);
            renderSoloBtn(data.queue);
            renderToolbar(data.queue);
        }
        else
        {
            errorDlg(data.error);
        }
    });

    socket.on("queue_left", async (data) => {
        console.log("queue_left notification", data);
        if(data.message == "done")
        {
            renderSoloBtn(null);
            renderToolbar(null);
        }
        else
        {
            errorDlg(data.error);
        }
    });

    socket.on("queue_error", async (data) => {
        errorDlg(data.error);
    });

    socket.on("queue_settings_upd", async (data) => {
        if(data.regions !== undefined)
        {
            regions = data.regions;
            $(".solo-servers-num-selected").text(regions.length);
            availableRegions.map(loc => {
                if(regions.includes(loc))
                {                    
                    if(!$(".solo-servers [name=solo-locations][value="+loc+"]").is(":checked"))
                    {
                        $(".solo-servers [name=solo-locations][value="+loc+"]").prop("checked", true);
                    }
                }
                else
                {
                    if($(".solo-servers [name=solo-locations][value="+loc+"]").is(":checked"))
                    {
                        $(".solo-servers [name=solo-locations][value="+loc+"]").prop("checked", false);
                    }
                }
            });
        }
    });

    socket.on("queue_confirmation", async (data) => {
        console.log("queue_confirmation notification", data);
        soundManager.playSound("match_found");
        let res = await confirmMatchDlg(data);
        /*if(res == 1)
        {
            let res = await KTAPI.confirmMatch();
            if(res.message == "done")
            {
                console.log("confirmed match action", res);
            }
            else
            {
                errorDlg(res.error);
            }
        }
        else
        {
            let res = await KTAPI.cancelMatch();
            if(res.message == "done")
            {
                console.log("canceled match action", res);
            }
            else
            {
                errorDlg(res.error);
            }
        }*/
        
    });

    socket.on("queue_confirmed", async (data) => {
        console.log("queue_confirmed notification", data);
        if(confimDialog != null)
        {
            let slot = `<div class="symbol symbol-40px opacity-50">
                            <span class="symbol-label border border-gray-400">
                                <i class="fad fa-user-check fs-3"></i>
                            </span>
                        </div>`;
            
            confimDialog.cancelAutoHide();
            $(".solo-confirm-match").remove();
            $(".solo-queue-list").empty();
            //$(".solo-queue-list").removeClass("flex-column").addClass("flex-row gap-2");
            $(".solo-queue-list").html(`<div class="text-gray-900 fs-6 mb-2"><span class="solo-queue-players-num">0</span>/${data.max} Players Ready</div><div class="solo-queue-players w-100 d-flex flex-row justify-content-center align-items-center gap-2">${slot.repeat(data.max)}</div>`);
            
            // look for each element of solo-queue-players
            for(let index = 0; index < data.num; index++)
            {
                $(".solo-queue-players .symbol").eq(index).removeClass("opacity-50");
                $(".solo-queue-players .symbol").eq(index).find(".symbol-label").removeClass("border-gray-400").addClass("border-primary bg-light-primary");
                $(".solo-queue-players .symbol").eq(index).find("i").removeClass("").addClass("text-primary");
            };
            $(".solo-queue-players-num").text(data.num);
            
        }
        //router.navigate("match/"+data.lobby);
    });

    socket.on("queue_other_confirmed", async (data) => {
        console.log("queue_other_confirmed notification", data);
        if(confimDialog != null && !$(".solo-confirm-match").length)
        {
            let slot = `<div class="symbol symbol-40px opacity-50">
                            <span class="symbol-label border border-gray-400">
                                <i class="fad fa-user-check fs-3"></i>
                            </span>
                        </div>`;

            $(".solo-queue-players .symbol").eq(data.num - 1).removeClass("opacity-50");
            $(".solo-queue-players .symbol").eq(data.num - 1).find(".symbol-label").removeClass("border-gray-400").addClass("border-primary bg-light-primary");
            $(".solo-queue-players .symbol").eq(data.num - 1).find("i").removeClass("").addClass("text-primary");
            $(".solo-queue-players-num").text(data.num);
        }
    });

    socket.on("queue_not_confirmed", async (data) => {
        console.log("queue_not_confirmed notification", data);
        if(confimDialog != null)
        {
            confimDialog.hide();
        }
        renderSoloBtn(null);
        renderToolbar(null);
    });

    socket.on("queue_cooldown", async (data) => {
        console.log("queue_cooldown notification", data);
        errorDlg("cooldown_time_notconfirm");
    });

    socket.on("queue_group_dissolved", async (data) => {
        console.log("queue_group_dissolved notification", data);
        if(confimDialog != null)
        {
            confimDialog.hide();
        }
        renderSoloBtn(data.queue);
        renderToolbar(data.queue);
    });

    socket.on("queue_success", async (data) => {
        console.log("queue_success notification", data);
        if(confimDialog != null)
        {
            confimDialog.hide();
        }
        renderSoloBtn(null);
        renderToolbar(null);
    });

    socket.on("lobby_created_by_mm", async (data) => {
        console.log("lobby_created_by_mm notification", data);
        router.navigate("lobby/"+data.lobbyId);
    });

};

export { soloSocket, soloOffscreenInit };



/**
 * 
 *  RENDER FUNCTIONS
 * 
 */



export default play;